import { hasValue } from 'utils/hasValue';

import type { PostDisbursementPayoutBatches422 } from 'api';

import { useCsvDownload } from 'hooks/useCsvDownload';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';

type DownloadErrorButtonProps = {
  errorData: PostDisbursementPayoutBatches422;
  resetForm?: () => void;
};

export const DownloadErrorButton = ({
  errorData,
  resetForm
}: DownloadErrorButtonProps) => {
  const { downloadCsv } = useCsvDownload();
  const data = errorData.data;

  return hasValue(data) ? (
    <PrimaryButton
      className="w-full"
      danger
      onClick={() => downloadCsv(data.content, data.filename)}
    >
      Download CSV error report
    </PrimaryButton>
  ) : (
    <PrimaryButton
      size="large"
      className="mt-4 w-full"
      onClick={() => {
        resetForm?.();
      }}
    >
      Try again
    </PrimaryButton>
  );
};
